module.exports = __webpack_public_path__ + "static/img/poster.335657e7.png";